import { z } from 'zod'

export const TypesAllergy = z.enum(['REMEDY', 'FOOD', 'OTHERS'])

const AllergyPatient = z.object({
  id: z.string(),
  name: z.string(),
  typeAllergy: TypesAllergy,
  createdAt: z.string().date()
})

export type AllergyPatient = z.infer<typeof AllergyPatient>
export type TypesAllergy = z.infer<typeof TypesAllergy>
